export default __webpack_public_path__ + "static/13_OnAGoldenCord-858c1896f356a170f52ba8f59a14cd9c.pdf";